function _1(md){return(
md`# Simple Table`
)}

function _table(tableSort,d3,DOM,$0,chartData,m2hectares,pct)
{
 tableSort; 
 let d = d3.select(DOM.element('div'))
 d.attr('class', 'table-responsive');
 
 let up = '▲';
 let down = '▼';
  
 let t = d.append('table').attr('class', 'table');
 let columns = ['Class', 'Name', 'Area (ha)', 'Area %'];
 let sort = ['Class', 'name', 'value', 'value']; 
 t.append('thead')
   .append('tr')
  .selectAll('th')
   .data(columns)
   .enter()
   .append('th')
   .attr('role','button')
   .style('cursor', 'pointer')
   .text((d,i) => {
      if(($0.value).column == sort[i]) {
        let currentOrder = ($0.value).order;
        return d + ' ' + (currentOrder > 0 ? up : down);
      }
      return d;
    })
   .on('click', (d,i) => {
      let sameColumn = ($0.value).column == sort[i];
      let currentOrder = ($0.value).order;
      let newSort = { column:sort[i], order: sameColumn ? currentOrder * -1 : currentOrder };     
      $0.value = newSort;      
   });
 
  let sortedData = chartData.sort((a,b) => {
    let c = $0.value.column;
    a = a[c];
    b = b[c];
    let o = $0.value.order;
    if (!isNaN(a) && !isNaN(b)) {
      return o * (a-b);
    }
    return a ? o * a.localeCompare(b) : o;
  });
  
  t.append('tbody')
   .selectAll('tr').data(sortedData)
   .enter()
   .append('tr')
   .selectAll('td')
    .data(d => [d.Class, d.name, m2hectares(d.value), pct(d.value)])
    .enter()
    .append('td')
    .text(d => d);
  
  return d.node()
}


function _chartData(gis,rawData,includeOther,classDelta){return(
gis.AreaQuery.responseToGroupableTabularData(rawData, includeOther)
   .map(cl => {
     return {
       ...cl,
       Class: cl.Class !== null && cl.Class !== undefined ? `${parseInt(cl.Class) + classDelta}`: undefined
     }
   })
)}

function _classDelta(){return(
1
)}

function _includeOther(){return(
true
)}

function _gis(require){return(
require("@manaakiwhenua/frag-helper@0.0.7/dist/umd/gis-portals-transformers/index.js")
)}

function _d3(require){return(
require('d3@5')
)}

function _rawData()
{
  return {
  "response": {
    "area": 1.7693655E8,
    "layers": [
      {
        "name": "lcdb4_veg",
        "raster": false,
        "rows": [
          {
            "columns": [
              {
                "name": "Class",
                "value": "0"
              },
              {
                "name": "Class Description",
                "value": "Tussock"
              },
              {
                "name": "Class Color",
                "value": "#DBB052"
              },
              {
                "name": "Class Area",
                "value": 430854.5124593499
              },
              {
                "name": "Class Abbreviation",
                "value": "Tsck"
              },
              {
                "name": "Class Flags",
                "value": 7
              },
              {
                "name": "Class Flags Hash",
                "value": {
                  "SHOW_LONG_NAME_IN_CONTENTS": true,
                  "HIDE_FROM_CONTENTS_PAGE": false,
                  "VISUALISATION": true,
                  "QUERY_ABLE": true
                }
              }
            ],
            "number": 1
          },
          {
            "columns": [
              {
                "name": "Class",
                "value": "2"
              },
              {
                "name": "Class Description",
                "value": "Exotic Grassland"
              },
              {
                "name": "Class Color",
                "value": "#ABCD66"
              },
              {
                "name": "Class Area",
                "value": 7.860501814038701E7
              },
              {
                "name": "Class Abbreviation",
                "value": "ExGr"
              },
              {
                "name": "Class Flags",
                "value": 7
              },
              {
                "name": "Class Flags Hash",
                "value": {
                  "SHOW_LONG_NAME_IN_CONTENTS": true,
                  "HIDE_FROM_CONTENTS_PAGE": false,
                  "VISUALISATION": true,
                  "QUERY_ABLE": true
                }
              }
            ],
            "number": 2
          },
          {
            "columns": [
              {
                "name": "Class",
                "value": "3"
              },
              {
                "name": "Class Description",
                "value": "Herbaceous (Wetlands)"
              },
              {
                "name": "Class Color",
                "value": "#508474"
              },
              {
                "name": "Class Area",
                "value": 166968.90070252414
              },
              {
                "name": "Class Abbreviation",
                "value": "Herb"
              },
              {
                "name": "Class Flags",
                "value": 7
              },
              {
                "name": "Class Flags Hash",
                "value": {
                  "SHOW_LONG_NAME_IN_CONTENTS": true,
                  "HIDE_FROM_CONTENTS_PAGE": false,
                  "VISUALISATION": true,
                  "QUERY_ABLE": true
                }
              }
            ],
            "number": 3
          },
          {
            "columns": [
              {
                "name": "Class",
                "value": "4"
              },
              {
                "name": "Class Description",
                "value": "Native Scrub"
              },
              {
                "name": "Class Color",
                "value": "#8C7922"
              },
              {
                "name": "Class Area",
                "value": 5621003.254176883
              },
              {
                "name": "Class Abbreviation",
                "value": "NScr"
              },
              {
                "name": "Class Flags",
                "value": 7
              },
              {
                "name": "Class Flags Hash",
                "value": {
                  "SHOW_LONG_NAME_IN_CONTENTS": true,
                  "HIDE_FROM_CONTENTS_PAGE": false,
                  "VISUALISATION": true,
                  "QUERY_ABLE": true
                }
              }
            ],
            "number": 4
          },
          {
            "columns": [
              {
                "name": "Class",
                "value": "5"
              },
              {
                "name": "Class Description",
                "value": "Exotic Scrub"
              },
              {
                "name": "Class Color",
                "value": "#C4BB89"
              },
              {
                "name": "Class Area",
                "value": 30762.06097820055
              },
              {
                "name": "Class Abbreviation",
                "value": "EScr"
              },
              {
                "name": "Class Flags",
                "value": 7
              },
              {
                "name": "Class Flags Hash",
                "value": {
                  "SHOW_LONG_NAME_IN_CONTENTS": true,
                  "HIDE_FROM_CONTENTS_PAGE": false,
                  "VISUALISATION": true,
                  "QUERY_ABLE": true
                }
              }
            ],
            "number": 5
          },
          {
            "columns": [
              {
                "name": "Class",
                "value": "6"
              },
              {
                "name": "Class Description",
                "value": "Native Forest"
              },
              {
                "name": "Class Color",
                "value": "#75923C"
              },
              {
                "name": "Class Area",
                "value": 9.009884290136646E7
              },
              {
                "name": "Class Abbreviation",
                "value": "NFor"
              },
              {
                "name": "Class Flags",
                "value": 7
              },
              {
                "name": "Class Flags Hash",
                "value": {
                  "SHOW_LONG_NAME_IN_CONTENTS": true,
                  "HIDE_FROM_CONTENTS_PAGE": false,
                  "VISUALISATION": true,
                  "QUERY_ABLE": true
                }
              }
            ],
            "number": 6
          },
          {
            "columns": [
              {
                "name": "Class",
                "value": "7"
              },
              {
                "name": "Class Description",
                "value": "Exotic Forest"
              },
              {
                "name": "Class Color",
                "value": "#4F6228"
              },
              {
                "name": "Class Area",
                "value": 1359452.2613003575
              },
              {
                "name": "Class Abbreviation",
                "value": "EFor"
              },
              {
                "name": "Class Flags",
                "value": 7
              },
              {
                "name": "Class Flags Hash",
                "value": {
                  "SHOW_LONG_NAME_IN_CONTENTS": true,
                  "HIDE_FROM_CONTENTS_PAGE": false,
                  "VISUALISATION": true,
                  "QUERY_ABLE": true
                }
              }
            ],
            "number": 7
          }
        ]
      }
    ],
    "pointHeight": 0
  }
}
}


function _total(rawData){return(
rawData.response.area
)}

function _pctFmt(d3)
{
  const specifier = d3.formatSpecifier('.1%');
  specifier.trim = true;
  return d3.format(specifier);
}


function _View(){return(
class View {
  constructor(value) {
    Object.defineProperties(this, {
      _list: {value: [], writable: true},
      _value: {value, writable: true}
    });
  }
  get value() {
    return this._value;
  }
  set value(value) {
    this._value = value;
    this.dispatchEvent({type: "input", value});
  }
  addEventListener(type, listener) {
    if (type != "input" || this._list.includes(listener)) return;
    this._list = [listener].concat(this._list);
  }
  removeEventListener(type, listener) {
    if (type != "input") return;
    this._list = this._list.filter(l => l !== listener);
  }
  dispatchEvent(event) {
    const p = Promise.resolve(event);
    this._list.forEach(l => p.then(l));
  }
}
)}

function _pct(pctFmt,total){return(
d => pctFmt(d / total)
)}

function _m2hectares(){return(
function m2hectares(m2) {
  let hectares = m2/10000;
  
  if (hectares < 1) {
    return `< 1ha`;
  }
  return `${Math.round(hectares).toLocaleString()}ha`;
}
)}

function _tableSort(View){return(
new View({column:'Class', order:1})
)}

export default function define(runtime, observer) {
  const main = runtime.module();
  main.variable(observer()).define(["md"], _1);
  main.variable(observer("table")).define("table", ["tableSort","d3","DOM","viewof tableSort","chartData","m2hectares","pct"], _table);
  main.variable(observer("chartData")).define("chartData", ["gis","rawData","includeOther","classDelta"], _chartData);
  main.variable(observer("classDelta")).define("classDelta", _classDelta);
  main.variable(observer("includeOther")).define("includeOther", _includeOther);
  main.variable(observer("gis")).define("gis", ["require"], _gis);
  main.variable(observer("d3")).define("d3", ["require"], _d3);
  main.variable(observer("rawData")).define("rawData", _rawData);
  main.variable(observer("total")).define("total", ["rawData"], _total);
  main.variable(observer("pctFmt")).define("pctFmt", ["d3"], _pctFmt);
  main.variable(observer("View")).define("View", _View);
  main.variable(observer("pct")).define("pct", ["pctFmt","total"], _pct);
  main.variable(observer("m2hectares")).define("m2hectares", _m2hectares);
  main.variable(observer("viewof tableSort")).define("viewof tableSort", ["View"], _tableSort);
  main.variable(observer("tableSort")).define("tableSort", ["Generators", "viewof tableSort"], (G, _) => G.input(_));
  return main;
}
